import React, {useContext} from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import SimpleHeader from "../components/SimpleHeader";
import { AiOutlinePushpin } from "react-icons/ai";
import { LanguageContext } from "../languages/LanguageContext";
import { Link } from "react-router-dom";
import PageTitle from "../components/PageTitle";

const About = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <>
            <PageTitle title='About Us' />
            <Header />
            <div className='main-container'>
                <SimpleHeader
                    title={"about"}
                    route={"about"}
                    url={"about"}
                />
                <div className='about-container flex col'>
                    <div className='experience-container max-w'>
                        <div className='flex gap-2 wrap'>
                            <p>
                                <h2 className='w-full'>{translations[language]["aboutTitle"]}</h2>
                                {translations[language]["aboutText1"]}
                                <br />
                                <br />
                                {translations[language]["aboutText2"]}
                            </p>
                            <img src='/images/about/about-2.jpg' alt='erasmus-students'/>
                        </div>
                    </div>
                    <div className='offer-container flex wrap max-w'>
                        <h2 className='w-full'>{translations[language]["weOffer"]}</h2>
                        <div className='flex col'>
                            <h3>{translations[language]["mobility1"]}</h3>
                            <div className='list flex col gap-sm'>
                                <div className='list-item'>
                                    <span className='point'><AiOutlinePushpin className='icon' /></span>
                                    {translations[language]["aboutList1"]}
                                </div>
                                <div className='list-item'>
                                    <span className='point'><AiOutlinePushpin className='icon' /></span>
                                    {translations[language]["aboutList2"]}
                                </div>
                                <div className='list-item'>
                                    <span className='point'><AiOutlinePushpin className='icon' /></span>
                                    {translations[language]["aboutList3"]}
                                </div>
                            </div>
                        </div>
                        <div className='flex col'>
                            <h3>{translations[language]["mobility2"]}</h3>
                            <div className='list flex col gap-sm'>
                                <div className='list-item'>
                                    <span className='point'><AiOutlinePushpin className='icon' /></span>
                                    {translations[language]["aboutList4"]}
                                </div>
                                <div className='list-item'>
                                    <span className='point'><AiOutlinePushpin className='icon' /></span>
                                    {translations[language]["aboutList5"]}
                                </div>
                                <div className='list-item'>
                                    <span className='point'><AiOutlinePushpin className='icon' /></span>
                                    {translations[language]["aboutList6"]}
                                </div>
                                <div className='list-item'>
                                    <span className='point'><AiOutlinePushpin className='icon' /></span>
                                    {translations[language]["aboutList7"]}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='more-container flex max-w gap-2 wrap jc-se'>
                        <img src='/images/about/about-1.jpg' alt='our-erasmus-graduates' />
                        <p><h2 className='w-full'>{translations[language]["aboutTitle2"]}</h2>{translations[language]["aboutText3"]}</p>
                    </div>
                    <div className='document-container max-w'>
                        <h2 className='w-full'>{translations[language]["documentTitle"]}</h2>
                        <div className='flex col'>
                            <div className='list flex col gap-sm'>
                                <div className='list-item ai-c'>
                                    <span className='point'><AiOutlinePushpin className='icon' /></span>
                                    <p>
                                        <Link to='/docs/europass.pdf' target='_blank'>Europass</Link>{translations[language]["document1"]}
                                    </p>
                                </div>
                                <div className='list-item ai-c'>
                                    <span className='point'><AiOutlinePushpin className='icon' /></span>
                                    <p>
                                        {translations[language]["document2-1"]}
                                        <Link to='/docs/ecvet_memorandum_of_understanding.pdf' target='_blank'>(Memorandum of Understanding - MoU)</Link>
                                        {translations[language]["document2-2"]}
                                    </p>
                                </div>
                                <div className='list-item ai-c'>
                                    <span className='point'><AiOutlinePushpin className='icon' /></span>
                                    <p>
                                        <Link to='/docs/zertifikat_bvoe_schueler.pdf' target='_blank'>{translations[language]["certificationStudent"]}</Link>
                                        {translations[language]["document3"]}
                                        <Link to='/docs/zertifikat_bvoe_lehrer.pdf' target='_blank'>{translations[language]["certificationTeacher"]}</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default About;